/* Hamsterbrain Packs - curated bundles of real in-stock singles.

   Reads assets/curated-packs.json, rebuilt from live stock by the data
   pipeline. Nothing here is a product: the button fills the cart with the
   actual singles, so inventory decrements normally and a pack that loses a
   card simply rebuilds smaller.

   MARKUP. Every pack is rendered with the THEME'S OWN card components -
   grid/product-grid, card-wrapper, card card--card card--media, card__inner
   ratio, card__media, card__content, card__information, card__heading,
   card__badge, badge, price, button. Nothing here invents a look: colours,
   type scale, corners, shadows and hover states all come from Trade's
   settings, so the page follows the theme instead of drifting from it.
   hb-curated.css holds only what the theme has no component for.

   ACCURACY. The JSON is a snapshot and drifts between rebuilds. The harmful
   direction is showing a sold card as buyable, so - as hb-companion.js already
   does for suggestions - a pack is VERIFIED against /products/<handle>.js the
   moment it is opened: prices corrected, sold cards dropped, total recomputed,
   and the cart built from the verified variant ids. */
(function () {
  var M = document.getElementById("hb-curated");
  if (!M) return;
  var URL_PACKS = M.getAttribute("data-packs"),
      DISCOUNT = (M.getAttribute("data-discount") || "").trim(),
      PACKS = [], VIEW = [], SEL = null, GEN = "", CK = null,
      LIVE = {},                 // handle -> {ok, id, price, nm} | null
      FORMATS = [],
      F = { kind: "", fmt: "", q: "" };
  var THIN = 8;                  // below this many surviving cards, say so
  // Each pack card pulls a Scryfall art crop, ~61 KB. Rendering all 40 at once
  // is 2.5 MB and 40 requests to Scryfall on every page view. Paginate.
  var PAGE = 12, shown = PAGE;

  function money(n) { return "$" + (Math.round(n * 100) / 100).toFixed(2); }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function front(s) { return String(s || "").split(" // ")[0]; }
  var HANDLE_TAIL = /-([a-z0-9]{2,6})-([0-9]+[a-z]?)$/;
  function cardImg(c) {
    /* The handle carries the set code and collector number, so we can ask
       Scryfall for the exact printing we are actually selling rather than
       whatever the newest one happens to be. */
    var m = HANDLE_TAIL.exec(c.handle || "");
    if (m) return "https://api.scryfall.com/cards/" + m[1] + "/" + m[2] +
      "?format=image&version=small";
    return "https://api.scryfall.com/cards/named?exact=" +
      encodeURIComponent(front(c.name)) + "&format=image&version=small";
  }
  var PIP = { W: "White", U: "Blue", B: "Black", R: "Red", G: "Green" };
  function ident(c) {
    var ci = c.ci || "";
    if (!ci) return c.t === "Land" ? "Land" : "Colourless";
    if (ci.length === 1) return PIP[ci] || ci;
    return ci;
  }

  function art(name) {
    return "https://api.scryfall.com/cards/named?exact=" +
      encodeURIComponent(front(name)) + "&format=image&version=art_crop";
  }
  var KIND_LABEL = { core: "Staples", fmt: "Staples", guild: "Two-colour",
                     land: "Manabase", arch: "Deck starter" };
  var KIND_GROUP = { core: "staples", fmt: "staples", guild: "guild",
                     land: "land", arch: "arch" };

  /* ---- verification ------------------------------------------------- */

  function liveOf(p) {
    var cards = [], gone = 0, total = 0, checked = 0,
        ckUs = 0, ckThem = 0, ckLines = 0;
    p.cards.forEach(function (c) {
      var v = LIVE[c.handle], n = c.n || 1;
      if (v === undefined) {
        cards.push({ c: c, price: c.price, n: n, live: false });
        total += c.price * n;
        if (c.ck) { ckUs += c.price * n; ckThem += c.ck * n; ckLines++; }
        return;
      }
      checked++;
      if (!v || !v.ok) { gone++; return; }
      cards.push({ c: c, price: v.price, n: n, live: true, id: v.id });
      total += v.price * n;
      if (c.ck && v.nm) { ckUs += v.price * n; ckThem += c.ck * n; ckLines++; }
    });
    var copies = 0;
    cards.forEach(function (x) { copies += x.n; });
    return { cards: cards, gone: gone, total: total, copies: copies,
             ckUs: ckUs, ckThem: ckThem, ckLines: ckLines,
             done: checked === p.cards.length, checked: checked };
  }

  async function lookup(handle) {
    if (LIVE[handle] !== undefined) return;
    try {
      var r = await fetch("/products/" + encodeURIComponent(handle) + ".js");
      if (!r.ok) { LIVE[handle] = null; return; }
      var p = await r.json();
      var av = (p.variants || []).filter(function (v) { return v.available; });
      if (!av.length) { LIVE[handle] = null; return; }
      av.sort(function (a, b) { return a.price - b.price; });
      // Card Kingdom's published figure is a near-mint price. Only a near-mint
      // copy of ours belongs in that comparison.
      LIVE[handle] = { ok: true, id: av[0].id, price: av[0].price / 100,
                       nm: /near\s*mint/i.test(av[0].title || "") };
    } catch (e) { LIVE[handle] = null; }
  }

  async function verify(p, onProgress) {
    var list = p.cards.map(function (c) { return c.handle; });
    for (var i = 0; i < list.length; i += 8) {
      await Promise.all(list.slice(i, i + 8).map(lookup));
      if (onProgress) onProgress(Math.min(i + 8, list.length), list.length);
    }
  }

  /* ---- grid: the theme's own product card ---------------------------- */

  function priceHTML(amount, prefix) {
    return '<div class="price"><div class="price__container"><div class="price__regular">' +
      (prefix ? '<span class="hbcp-approx">' + prefix + "</span> " : "") +
      '<span class="price-item price-item--regular">' + money(amount) +
      "</span></div></div></div>";
  }

  function packCard(p, i) {
    var L = liveOf(p),
        ratio = "--ratio-percent: 72%;",
        top = L.cards.slice(0, 3).map(function (x) { return x.c.name; }).join(", "),
        more = L.cards.length - 3;
    return '<li class="grid__item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover hbcp-pack" data-i="' + i + '" tabindex="0">' +
      '<div class="card card--card card--media color-scheme-2 gradient" style="' + ratio + '">' +
      '<div class="card__inner ratio" style="' + ratio + '">' +
      '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
      '<img src="' + art(p.cards[0].name) + '" loading="lazy" alt="" width="626" height="457"></div></div>' +
      '<div class="card__content"><div class="card__information"></div>' +
      '<div class="card__badge bottom left"><span class="badge">' +
      esc(p.badge || KIND_LABEL[p.kind] || "Pack") + "</span></div></div></div>" +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading h5"><a href="#" class="full-unstyled-link">' + esc(p.title) + "</a></h3>" +
      '<p class="hbcp-line caption">' + esc(p.fmt || "") + " &middot; " + L.copies + " cards" +
      (L.copies !== L.cards.length ? " (" + L.cards.length + " different)" : "") + "</p>" +
      '<p class="hbcp-blurb">' + esc(p.blurb) + "</p>" +
      '<p class="hbcp-line caption">' + esc(top) + (more > 0 ? ", and " + more + " more" : "") + "</p>" +
      '<div class="card-information">' + priceHTML(L.total, L.done ? "" : "about") + "</div>" +
      "</div></div></div></div></li>";
  }

  function render() {
    var grid = M.querySelector(".hbcp-grid"),
        count = M.querySelector(".hbcp-count");
    count.innerHTML = "Showing <b>" + Math.min(shown, VIEW.length) + "</b> of " +
      VIEW.length + " packs" + (VIEW.length < PACKS.length ? " (" + PACKS.length + " in all)" : "");
    grid.innerHTML = VIEW.length
      ? VIEW.slice(0, shown).map(packCard).join("")
      : '<li class="grid__item hbcp-empty"><p>No packs match that. Try clearing the search.</p></li>';
    var more = M.querySelector(".hbcp-more");
    if (more) {
      more.hidden = shown >= VIEW.length;
      more.textContent = "Show " + Math.min(PAGE, VIEW.length - shown) + " more";
    }
  }

  function applyFilters() {
    var q = F.q.toLowerCase().trim();
    VIEW = PACKS.filter(function (p) {
      if (F.fmt && p.fmt !== F.fmt) return false;
      if (F.kind && KIND_GROUP[p.kind] !== F.kind) return false;
      if (!q) return true;
      if (p.title.toLowerCase().indexOf(q) > -1) return true;
      return p.cards.some(function (c) { return c.name.toLowerCase().indexOf(q) > -1; });
    });
    shown = PAGE;
    render();
  }

  /* ---- one pack ------------------------------------------------------ */

  function packBody(p, state) {
    var L = liveOf(p), status;
    if (state && state.busy) {
      status = "Checking every card against the shelf" +
        (state.n ? " — " + state.n + "/" + state.of : "") + "…";
    } else if (L.done) {
      status = "Every card checked just now" +
        (L.gone ? " — " + L.gone + " had sold and " +
          (L.gone === 1 ? "has" : "have") + " been removed" : "") + ".";
    } else {
      status = "Prices from our last stock rebuild" +
        (GEN ? " (" + esc(GEN.slice(0, 10)) + ")" : "") + ".";
    }

    var vs = "";
    if (CK && L.ckThem > L.ckUs * 1.02 && L.cards.length &&
        L.ckLines >= Math.ceil(L.cards.length * 0.6)) {
      var save = L.ckThem - L.ckUs, pct = Math.round(100 * save / L.ckThem);
      vs = '<div class="hbcp-vs color-scheme-3 gradient">' +
        '<p class="h5">' + money(save) + " less than Card Kingdom</p>" +
        "<p>The same printings at Card Kingdom’s listed near-mint retail: " +
        money(L.ckThem) + ". Ours: " + money(L.ckUs) + " — " + pct + "% less.</p>" +
        '<p class="caption hbcp-fine">Compared on ' + L.ckLines + " of " + L.cards.length +
        " cards, matched on set and collector number, using Card Kingdom retail prices " +
        "published by MTGJSON" + (CK.quoted ? " on " + esc(CK.quoted) : "") +
        ". We are not affiliated with Card Kingdom.</p></div>";
    }

    var thin = L.done && L.cards.length < THIN
      ? '<p class="hbcp-thin">This one has been picked over — only ' +
        L.cards.length + " different cards left in it. It rebuilds overnight, or try another pack.</p>"
      : "";

    return '<div class="hbcp-head">' +
      "<div><h2 class=\"h4\">" + esc(p.title) + "</h2>" +
      '<p class="caption">' + L.copies + " cards" +
      (L.copies !== L.cards.length ? " (" + L.cards.length + " different)" : "") +
      " &middot; " + esc(p.fmt || "") + " &middot; " + money(L.total) + "</p></div>" +
      '<button type="button" class="hbcp-close" aria-label="Close">&times;</button></div>' +
      '<div class="hbcp-stats">' +
      '<div class="hbcp-stat"><b>' + L.copies + '</b><span>cards' +
      (L.copies !== L.cards.length ? " · " + L.cards.length + " different" : "") + '</span></div>' +
      '<div class="hbcp-stat"><b>' + money(L.total) + '</b><span>you pay</span></div>' +
      (L.ckThem > L.ckUs * 1.02 && L.ckLines
        ? '<div class="hbcp-stat is-save"><b>' + money(L.ckThem - L.ckUs) + '</b><span>less than Card Kingdom</span></div>'
        : '<div class="hbcp-stat"><b>' + esc(p.fmt || "") + '</b><span>format</span></div>') +
      '</div>' +
      '<div class="hbcp-scroll">' +
      vs +
      '<div class="hbcp-why rte"><p class="caption">How we picked these</p><p>' + esc(p.why) + "</p></div>" +
      thin +
      '<ul class="hbcp-cards" role="list">' +
      L.cards.map(function (x) {
        var c = x.c, moved = x.live && Math.abs(x.price - c.price) >= 0.01,
            m = HANDLE_TAIL.exec(c.handle || ""),
            setnum = m ? m[1].toUpperCase() + " " + m[2] : "",
            sub = [];
        if (c.t === "Land") sub.push("Land");
        else {
          sub.push(ident(c));
          if (c.mv != null) sub.push("MV " + c.mv);
        }
        if (c.rank) sub.push("#" + c.rank);
        return '<li class="hbcp-tile">' +
          '<a class="hbcp-tile__link" href="/products/' + encodeURIComponent(c.handle) + '" target="_blank" rel="noopener">' +
          '<span class="hbcp-tile__frame">' +
          '<img class="hbcp-tile__img" src="' + cardImg(c) + '" loading="lazy" alt="' + esc(c.name) +
          '" width="146" height="204">' +
          (x.n > 1 ? '<span class="hbcp-tile__qty badge">' + x.n + '\u00d7</span>' : "") +
          (setnum ? '<span class="hbcp-tile__set">' + esc(setnum) + "</span>" : "") +
          "</span>" +
          '<span class="hbcp-tile__name">' + esc(c.name) + "</span>" +
          '<span class="hbcp-tile__sub" title="' +
          (c.rank ? "#" + c.rank + " most-played card on EDHREC" : "") + '">' +
          esc(sub.join(" \u00b7 ")) + "</span>" +
          '<span class="hbcp-tile__price">' +
          (moved ? '<s>' + money(c.price * x.n) + "</s> " : "") + money(x.price * x.n) +
          "</span></a></li>";
      }).join("") + "</ul>" +
      '</div><div class="hbcp-foot">' +
      '<button type="button" class="hbcp-addall button button--primary"' +
      (state && state.busy ? " disabled" : "") + ">" +
      (L.cards.length ? "Add all " + L.copies + " cards — " + money(L.total)
                      : "Nothing left in this pack") + "</button>" +
      '<span class="hbcp-addmsg caption"></span>' +
      '<p class="caption hbcp-fine">' + status +
      " You are only ever charged for what is actually in your cart.</p></div>";
  }

  function paint(p, state) {
    M.querySelector(".hbcp-modal__inner").innerHTML = packBody(p, state);
  }

  async function openPack(i) {
    SEL = VIEW[i];
    if (!SEL) return;
    var p = SEL;
    paint(p, { busy: true });
    M.querySelector(".hbcp-modal").hidden = false;
    document.body.classList.add("overflow-hidden");

    await verify(p, function (n, of) { if (SEL === p) paint(p, { busy: true, n: n, of: of }); });
    if (SEL === p) { paint(p, null); render(); }
  }

  function closePack() {
    M.querySelector(".hbcp-modal").hidden = true;
    document.body.classList.remove("overflow-hidden");
    SEL = null;
  }

  async function addAll(btn) {
    if (!SEL) return;
    var p = SEL, L = liveOf(p), msg = M.querySelector(".hbcp-addmsg");
    if (!L.cards.length) return;
    btn.disabled = true;
    msg.textContent = "Adding…";

    var items = L.cards.filter(function (x) { return x.id; })
                       .map(function (x) { return { id: x.id, quantity: x.n }; });
    if (!items.length) {
      msg.textContent = "Could not add these right now — please refresh.";
      btn.disabled = false;
      return;
    }
    function post(list) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: list })
      });
    }
    try {
      var add = await post(items), trimmed = false;
      if (add.status === 422) {
        /* Shopify rejects the whole cart if any one line asks for more copies
           than are left, and it will not say which. Falling back to a single
           copy of everything gets the buyer a cart instead of an error. */
        trimmed = true;
        items = items.map(function (i) { return { id: i.id, quantity: 1 }; });
        add = await post(items);
      }
      if (!add.ok) throw new Error("cart");
      var copies = items.reduce(function (a, i) { return a + i.quantity; }, 0);
      msg.textContent = "Added " + copies + " cards" +
        (trimmed ? " — one copy each, we were short on some playsets." : ".");
      document.dispatchEvent(new CustomEvent("hb:cart-updated"));
      setTimeout(function () {
        window.location = DISCOUNT
          ? "/discount/" + encodeURIComponent(DISCOUNT) + "?redirect=/cart"
          : "/cart";
      }, 900);
    } catch (e) {
      msg.textContent = "Cart error — please try again.";
      btn.disabled = false;
    }
  }

  /* ---- wiring -------------------------------------------------------- */

  function wire() {
    M.addEventListener("click", function (e) {
      var card = e.target.closest(".hbcp-pack");
      if (card) { e.preventDefault(); openPack(+card.getAttribute("data-i")); return; }
      if (e.target.closest(".hbcp-close")) { closePack(); return; }
      if (e.target.classList.contains("hbcp-modal")) { closePack(); return; }
      var aa = e.target.closest(".hbcp-addall");
      if (aa) { addAll(aa); return; }
      if (e.target.closest(".hbcp-more")) { shown += PAGE; render(); return; }
      var kb = e.target.closest(".hbcp-kinds button");
      if (kb) {
        F.kind = kb.getAttribute("data-k");
        M.querySelectorAll(".hbcp-kinds button").forEach(function (b) {
          b.classList.toggle("button--primary", b === kb);
          b.classList.toggle("button--secondary", b !== kb);
        });
        applyFilters();
        return;
      }
      var fb = e.target.closest(".hbcp-formats button");
      if (fb) {
        F.fmt = fb.getAttribute("data-f");
        M.querySelectorAll(".hbcp-formats button").forEach(function (b) {
          b.classList.toggle("button--primary", b === fb);
          b.classList.toggle("button--secondary", b !== fb);
        });
        applyFilters();
      }
    });
    M.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.classList.contains("hbcp-pack")) {
        openPack(+e.target.getAttribute("data-i"));
      }
      if (e.key === "Escape") closePack();
    });
    var t = null, s = M.querySelector(".hbcp-search");
    if (s) s.addEventListener("input", function (e) {
      clearTimeout(t);
      var v = e.target.value;
      t = setTimeout(function () { F.q = v; applyFilters(); }, 180);
    });
  }

  async function init() {
    try {
      var r = await fetch(URL_PACKS);
      if (!r.ok) throw new Error("http " + r.status);
      var d = await r.json();
      PACKS = d.packs || [];
      GEN = d.generated_from_stock || "";
      CK = d.ck || null;
      FORMATS = d.formats || [];
      M.querySelector(".hbcp-loading").hidden = true;
      M.querySelector(".hbcp-main").hidden = false;

      var fbar = M.querySelector(".hbcp-formats");
      if (fbar && FORMATS.length) {
        fbar.innerHTML = '<button type="button" class="button button--primary" data-f="">All formats</button>' +
          FORMATS.map(function (f) {
            var n = PACKS.filter(function (p) { return p.fmt === f; }).length;
            return '<button type="button" class="button button--secondary" data-f="' + esc(f) + '">' +
              esc(f) + " " + n + "</button>";
          }).join("");
      }
      var note = M.querySelector(".hbcp-updated");
      if (note) {
        note.innerHTML = (GEN ? "Assembled from stock on " + esc(GEN.slice(0, 10)) + ". " : "") +
          "Every card is checked against the shelf again when you open a pack, " +
          "so what you see there is what you get.";
      }
      wire();
      applyFilters();
    } catch (e) {
      M.querySelector(".hbcp-loading").innerHTML = "<p>Could not load the packs just now. Please refresh.</p>";
    }
  }
  init();
})();
